import { render, staticRenderFns } from "./PrecioPlazosForm.vue?vue&type=template&id=948d6484"
import script from "./PrecioPlazosForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PrecioPlazosForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports